module.exports = __webpack_public_path__ + "img/modelBlue.895b6980.jpg";